import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MyContext } from '../../context/MyProvider';
import DeleteModal from '../Logout';

function Sidebar() {
    const { isOpenMain } = useContext(MyContext);


    const location = useLocation();
    return (
        <>
            <aside className={isOpenMain ? "active" : ""} >
                <div className='d-flex justify-content-center align-items-center header_logo_main'>
                    <div className="header-logo">
                        <img className='logo-xl' src="../images/png/logo.png" width={195.11} alt="" />
                        <img className='logo-sm d-none' src="../images/png/sm-logo.png" width={195.11} alt="" />
                    </div>
                    {/* <div onClick={toggleDropdownMain} className='d-none arrow-circle-right cursor-pointer '>
                        <img src="../images/png/arrow-circle-right.png" width={30} height={30} alt="" />
                    </div> */}
                </div>
                <div className='admin-title admin'>
                    <p>Admin</p>
                </div>
                <div className='d-none web'>
                    <div className='admin-title'>
                        <p>Admin</p>
                    </div>
                </div>
                <div className="sidebar-menulist">
                    <ul>
                        <li className={location.pathname === '/dashboard' ? 'active' : ''}>
                            {location.pathname === '/dashboard' ? (
                                <img src="../images/png/dashboard-light.png" width={22} height={18} alt="" />
                            ) : (
                                <img src="../images/png/dashboard.png" width={22} height={18} alt="" />
                            )}
                            <Link to='/dashboard'>Dashboard</Link>
                        </li>
                        <li className={location.pathname === '/category' ? 'active' : ''}>
                            {location.pathname === '/category' ? (
                                <img src="../images/png/category-light.png" width={20} height={20} alt="" />
                            ) : (
                                <img src="../images/png/category.png" width={20} height={20} alt="" />
                            )}
                            <Link to='/category'>Category Management</Link>
                        </li>
                        <li className={location.pathname === '/user' ? 'active' : ''}>
                            {location.pathname === '/user' ? (
                                <img src="../images/png/user-light.png" width={14.08} height={20} alt="" />
                            ) : (
                                <img src="../images/png/user.png" width={14.08} height={20} alt="" />
                            )}
                            <Link to='/user'>User Management</Link>
                        </li>
                        <li className={location.pathname === '/entry-form' || location.pathname === '/entry-form-add' || location.pathname === '/entry-form-edit' ? 'active' : ''}>
                            {location.pathname === '/entry-form' || location.pathname === '/entry-form-add' || location.pathname === '/entry-form-edit' ? (
                                <img src="../images/png/book-light.png" width={17} height={20} alt="" />
                            ) : (
                                <img src="../images/png/book.png" width={17} height={20} alt="" />
                            )}
                            <Link to='/entry-form'>Entry Form Management</Link>
                        </li>

                        <li className={location.pathname === '/template' ? 'active' : ''}>
                            {location.pathname === '/template' ? (
                                <img src="../images/png/template-light.png" width={24} height={24} alt="" />
                            ) : (
                                <img src="../images/png/template.png" width={24} height={24} alt="" />
                            )}
                            <Link to='/template'>Template Management</Link>
                        </li>

                        <li className={location.pathname === '/pricing-details' || location.pathname === '/pricing' ? 'active' : ''}>
                            {location.pathname === '/pricing-details' || location.pathname === '/pricing' ? (
                                <img src="../images/png/price-light.png" width={24} height={24} alt="" />
                            ) : (
                                <img src="../images/png/price.png" width={24} height={24} alt="" />
                            )}
                            <Link to='/pricing-details'>Subscription Pricing</Link>
                        </li>

                        <li className={location.pathname === '/terms-condition' ? 'active' : ''}>
                            {location.pathname === '/terms-condition' ? (
                                <img src="../images/png/terms_conditon.png " width={24} height={24} alt="" />
                            ) : (
                                <img src="../images/png/terms_conditon_light.png" width={24} height={24} alt="" />
                            )}
                            <Link to='/terms-condition'>Terms & Conditions</Link>
                        </li>

                        <li className={location.pathname === '/policy' ? 'active' : ''}>
                            {location.pathname === '/policy' ? (
                                <img src="../images/png/privacy-policy_light.png" width={24} height={24} alt="" />
                            ) : (
                                <img src="../images/png/privacy-policy.png" width={24} height={24} alt="" />
                            )}
                            <Link to='/policy'>Policy</Link>
                        </li>
                        <li>
                            <DeleteModal />
                        </li>
                    </ul>
                </div>
            </aside >
        </>
    )
}

export default Sidebar